module.exports = __webpack_public_path__ + "static/media/envelope.fc2dbf01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/envelope.svg
// module id = 2388
// module chunks = 0